import { FC, createContext, useContext, CSSProperties, ComponentProps, forwardRef } from 'react';
import { get375CssValue } from 'base/utils/dom-size';
import cn from 'classnames';

export type IRowProps = ComponentProps<'div'> & {
    gutter?: number | [number, number];
    colsPerRow?: number
};

export type IColProps = Globals.BasicHTMLProps & {
    span?: number;
};

const RowContext = createContext({
    xGutter: 0,
    yGutter: 0,
    colsPerRow: 1,
})

export const Row: FC<IRowProps> = props => {
    const {
        gutter = 0,
        colsPerRow = 1,
        className,
        style,
        children,
        ...rest
    } = props;

    const xGutter = typeof gutter === 'number' ? gutter : gutter[0];
    const yGutter = typeof gutter === 'number' ? gutter : gutter[1];

    const rowStyle: CSSProperties = {};
    if (xGutter > 0 && colsPerRow > 1) {
        rowStyle.marginLeft = `-${get375CssValue(xGutter)}`;
    }
    if (yGutter > 0) {
        rowStyle.marginTop = `-${get375CssValue(yGutter)}`;
    }


    return (
        <RowContext.Provider value={{ xGutter, yGutter, colsPerRow }}>
            <div
                className={cn(
                    colsPerRow > 1 ? 'flex flex-wrap' : 'flex flex-vertical',
                    className
                )}
                style={{
                    ...style,
                    ...rowStyle,
                }}
                {...rest}
            >
                {children}
            </div>
        </RowContext.Provider>
    )
};

export const Col = forwardRef<HTMLDivElement, IColProps>((props, ref) => {
    const {
        style,
        children,
        span = 1,
        ...rest
    } = props;

    const { xGutter, yGutter, colsPerRow } = useContext(RowContext);

    const colStyle: CSSProperties = { width: `${(100 / colsPerRow) * span}%` };
    if (xGutter > 0 && colsPerRow > 1) {
        colStyle.paddingLeft = get375CssValue(xGutter);
    }
    if (yGutter > 0) {
        colStyle.marginTop = get375CssValue(yGutter);
    }

    return (
        <div
            ref={ref}
            style={{
                ...style,
                ...colStyle,
            }}
            {...rest}
        >
            {children}
        </div>
    )
});
